<template>
  <div class="contents syuugyoukisoku detail">
    <h2>就業規則</h2>

    <div class="container">
      <template v-if="isLoading">
        <template v-if="!isError">
          <div class="loading-container">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i><br />
            <p>データ読み込み中...</p>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="baseinfo">

        </div><!-- /baseinfo -->

        <div class="maininfo">
          <vue-pdf-embed :source="src" />
        </div><!-- /maininfo -->
      </template>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.SYUUGYOU_KISOKU_LIST,
        }">メニューに戻る
        </router-link>
      </p>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, reactive, ref } from 'vue'
import VuePdfEmbed from 'vue-pdf-embed'
import { useSyuugyouKisokuInit } from '@/composable/syuugyoukisoku/init'
import { RouterConst } from '@/const/Router';
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {

    // 初期化
    const { getKisokuURL, isLoading, isError } = useSyuugyouKisokuInit();

    const route = useRoute();
    let kisokuId = parseInt(route.params.id as string, 10);

    const src = {
      url: getKisokuURL(kisokuId),
      // cMapUrl: '../../../../../node_modules/cmaps/',
      cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.11.338/cmaps/', // TODO: node_modules内のcmapから取りたい
      cMapPacked: true
    };

    return {
      src,
      isLoading,
      isError,
      RouterConst
    }
  },
  components: {
    VuePdfEmbed
  }
})
</script>
